import { render, staticRenderFns } from "./QGenericDataTableMixin.vue?vue&type=template&id=53d816aa&scoped=true&"
import script from "./QGenericDataTableMixin.vue?vue&type=script&lang=js&"
export * from "./QGenericDataTableMixin.vue?vue&type=script&lang=js&"
import style0 from "./QGenericDataTableMixin.vue?vue&type=style&index=0&id=53d816aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d816aa",
  null
  
)

export default component.exports